import { render, staticRenderFns } from "./History.html?vue&type=template&id=4d835d2a&scoped=true&"
import script from "./History.js?vue&type=script&lang=js&"
export * from "./History.js?vue&type=script&lang=js&"
import style0 from "./History.scss?vue&type=style&index=0&id=4d835d2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d835d2a",
  null
  
)

export default component.exports